import { surveyConstants } from '../_constants';
import { surveyService } from '../_services';


export const surveyActions = {

    responseAnalysisBySurveyId,
    getCampaignEmployeesByIDSurveyWise,
    getIndexByFilterDMG,
    getResponseAnalyticsPagination
    
    
};



//---------------------------------------------------------------------------------------------



function getResponseAnalyticsPagination(data) {
    return dispatch => {
        dispatch(request());
        surveyService.getResponseAnalyticsPagination(data)
            .then(
                survey => {
                    ////console.log(survey)
                    dispatch(success(survey));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: surveyConstants.GET_RESPONSE_ANALYTICS_PAGINATION_REQUEST } }
    function success(survey) { return { type: surveyConstants.GET_RESPONSE_ANALYTICS_PAGINATION_SUCCESS, survey } }
    function failure(error) { return { type: surveyConstants.GET_RESPONSE_ANALYTICS_PAGINATION_FAILURE, error } }
}

function getIndexByFilterDMG(data) {
    return dispatch => {
        dispatch(request());
        surveyService.getIndexByFilterDMG(data)
            .then(
                survey => {
                    ////console.log(survey)
                    dispatch(success(survey));
                },
                error => {
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: surveyConstants.GET_INDEX_BY_FILTER_DMG_REQUEST } }
    function success(survey) { return { type: surveyConstants.GET_INDEX_BY_FILTER_DMG_SUCCESS, survey } }
    function failure(error) { return { type: surveyConstants.GET_INDEX_BY_FILTER_DMG_FAILURE, error } }
}

function responseAnalysisBySurveyId(data) {
    return dispatch => {
        dispatch(request());
        surveyService.responseAnalysisBySurveyId(data)
            .then(
                survey => {
                    dispatch(success(survey));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: surveyConstants.RESPONSE_ANALYTICS_SURVEY_REQUEST } }
    function success(survey) { return { type: surveyConstants.RESPONSE_ANALYTICS_SURVEY_SUCCESS, survey } }
    function failure(error) { return { type: surveyConstants.RESPONSE_ANALYTICS_SURVEY_FAILURE, error } }
}



function getCampaignEmployeesByIDSurveyWise(data) {
    return dispatch => {
        dispatch(request());
        surveyService.getCampaignEmployeesByIDSurveyWise(data)
            .then(
                survey => {
                    dispatch(success(survey));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };
    function request() { return { type: surveyConstants.CAMPAIGN_EMPLOYEES_SURVEY_REQUEST } }
    function success(survey) { return { type: surveyConstants.CAMPAIGN_EMPLOYEES_SURVEY_SUCCESS, survey } }
    function failure(error) { return { type: surveyConstants.CAMPAIGN_EMPLOYEES_SURVEY_FAILURE, error } }
}